<script setup lang="ts">
import ScPage from '@/components/common/page/ScPage.vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { inject, ref } from 'vue';
import { WindowTool } from '@/components/common/window/WindowInterface';

const windowTool = inject<WindowTool | false>(WindowTool, false);
const value = ref(0);
const formats = [
  'ip:端口 账号 密码',
  'ip|端口|账号|密码|到期日期',
  'ip/端口/账号/密码',
  'ip/端口/账号/密码/地区',
];

async function onSubmit() {
  if (windowTool) {
    windowTool.close(value.value);
  }
}

function onCancel() {
  if (windowTool) {
    windowTool.close(false);
  }
}
</script>

<template>
  <sc-page>
    <div class="index-box">
      <div style="padding-bottom: 16px">请选择导出格式</div>
      <a-radio-group v-model:value="value" button-style="solid">
        <a-radio-button :key="key" :value="key" v-for="(_, key) in formats">
          格式{{ key + 1 }}
        </a-radio-button>
      </a-radio-group>
      <div style="padding: 16px 0">导出格式为: {{ formats[value] }}</div>
    </div>
    <div class="form-btn-group">
      <sc-btn :handler="onSubmit" text="确定" type="primary" />
      <sc-btn :handler="onCancel" style="margin-left: 10px" text="取消" />
    </div>
  </sc-page>
</template>

<style scoped lang="scss">
.index-box {
  flex-grow: 1;
  overflow: auto;
  padding: 16px;
}

.form-btn-group {
  border-top: 1px solid $color-content-border;
  padding: $spacing-medium;
}
</style>
